module.exports = __webpack_public_path__ + "static/media/somwarpet.12316728.jpg";